import { render } from "./payment-form.vue?vue&type=template&id=63098732&scoped=true"
import script from "./payment-form.vue?vue&type=script&lang=js"
export * from "./payment-form.vue?vue&type=script&lang=js"

import "./payment-form.vue?vue&type=style&index=0&id=63098732&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63098732"]])

export default __exports__